import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

interface ConsultationLayoutProps {
  children: React.ReactNode;
}

export const ConsultationLayout: React.FC<ConsultationLayoutProps> = ({
  children
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-sigma-grey via-white to-sigma-grey">
      <Header />
      <main className="container mx-auto px-4 py-8">
        {children}
      </main>
      <Footer />
    </div>
  );
};
